import { http } from "./httpServices";
import { GET_ALL_PRIVILEGE, PRIVILEGE, SETTINGS } from "./constants";

export function fetchAllPrivileges() {
  return http.get(`${SETTINGS}${PRIVILEGE}${GET_ALL_PRIVILEGE}`);
}

export function fetchPrivilegeFromId(id: any) {
  return http.get(`${SETTINGS}${PRIVILEGE}/${id}`);
}

export function addPrivilege(data: any) {
  return http.post(`${SETTINGS}${PRIVILEGE}`, data);
}

export function updatePrivilege(data: any, id: string | any) {
  return http.put(`${SETTINGS}${PRIVILEGE}/${id}`, data);
}
